function checkCartContents() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      if (cart.items.length === 1 && cart.items[0].product_id === window.sampleProductId) {
        console.log("Only the specific product is in the cart.");
        $("#cart .cart-buttons #checkout").attr('disabled', true);
      } else {
        console.log("Cart contains multiple products or the specific product is missing.");
      }
    })
    .catch(error => console.error('Error fetching cart:', error));
}

// Run on page load
document.addEventListener("DOMContentLoaded", checkCartContents);

// Listen for cart updates (Shopify AJAX API event)
document.addEventListener("cart:updated", checkCartContents);

$(document).ready(function () {
  let storeURL = window.location.origin;
  console.log("Store URL: ", storeURL);
  $(".samples-product-style .samples-product-inner-style .coupon-box-styles .apply-coupon-button-ajax").click(function(e) {
    e.preventDefault();
    let couponCodeVal = $(this).siblings("#coupon-code").val();
    let productID = $(this).attr('atc-product-id');

    // First, check if the product already exists in the cart
    if(couponCodeVal && couponCodeVal == 'MULTISENSORY'){
      $(this).siblings(".coupon-not-found-error").text("");
      $.getJSON('/cart.js', function(cart) {
        let productExists = cart.items.some(item => item.id == productID);

        if (!productExists) {
          // If the product is not in the cart, add it
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
              quantity: 1,
              id: productID
            },
            dataType: "json",
            success: function(data) {
              console.log("Product added:", data);
              location.href = storeURL + `/discount/${couponCodeVal}?redirect=/cart`;
            }
          });
        } else {
          console.log("Product is already in the cart.");
          location.href = storeURL + `/discount/${couponCodeVal}?redirect=/cart`
        }
      });
    }else{
      $(this).parents(".coupon-box-styles").siblings(".coupon-not-found-error").text("Please enter a valid coupon");
    }
  });
});